import {
    FORM_OPT_IN_CHANNELS_KEY,
    FORM_OPT_IN_KEY,
    OPT_IN_CHANNELS,
} from '@constants';
import { OptInChannel } from '@types';

export const isOptInChannels = (
    value: unknown
): value is Array<OptInChannel> => {
    return (
        Array.isArray(value) && value.every((v) => OPT_IN_CHANNELS.includes(v))
    );
};

/**
 * `optInChannels` is written only by the `EmailConsent` component. A form whose consent
 * config never reached the client therefore submits with `optIn` defaulted to `true` and no
 * channels: the consent notice was never displayed, so consent is dropped rather than
 * guessed. Returns whether that happened, so the caller can report it.
 */
export const processOptIns = (data: Record<string, unknown>): boolean => {
    const optIn =
        typeof data[FORM_OPT_IN_KEY] === 'boolean'
            ? data[FORM_OPT_IN_KEY]
            : false;
    const channels = data[FORM_OPT_IN_CHANNELS_KEY];

    delete data[FORM_OPT_IN_KEY];

    if (optIn && isOptInChannels(channels)) {
        data.optIns = channels.reduce(
            (acc, channel) => {
                acc[channel] = true;
                return acc;
            },
            {} as Record<OptInChannel, true>
        );
    }

    delete data[FORM_OPT_IN_CHANNELS_KEY];

    return optIn && !isOptInChannels(channels);
};
